export const getPercentage = (partialValue: number, totalValue: number) =>
    Math.round(((partialValue - totalValue) / partialValue) * 100);
